import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsSliderBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsSliderBlockEntity
